const LOCK = 'tasks.auth-refresh';

/**
 * Web Locks serializa el refresh entre pestañas. Sin soporte (o en tests) se ejecuta directo:
 * el mutex por pestaña del coordinador sigue evitando dos llamadas simultáneas.
 */
export const withRefreshLock = async <T>(fn: () => Promise<T>): Promise<T> => {
  const locks = globalThis.navigator?.locks;
  if (!locks) return fn();
  return locks.request(LOCK, fn) as Promise<T>;
};
